// extracted by mini-css-extract-plugin
module.exports = {"color":"ColorPicker_color__1Kb8P","swatch":"ColorPicker_swatch__1PeuA"};